import { gsap } from 'gsap';
import { SplashView } from "../SplashController"
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';
import { IDimOrientation, ResizeHelper } from '../../../../core/utils/ResizeHelper';
import { SoundConfig } from '../../../config/sound/SoundConfig';
import { SoundManager } from '../../../config/sound/SoundManager';
import { Helper } from '../../../../core/utils/Helper';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { TextStyleConfig } from '../../../config/translate/TextStyleConfig';
import { TranslationConfig } from '../../../config/translate/TranslationConfig';
import { GameData } from '../../../server/data/GameData';
import { GameAssets } from '../../../config/texture/GameAssets';
import { NolimitApplication } from '@nolimitcity/slot-launcher/bin/NolimitApplication';
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import { SanQuentin2 } from '../../../SanQuentin2';
import { MathHelper } from '../../../../core/utils/MathHelper';

export class SplashViewFreeSpins extends PIXI.Container implements SplashView  {

    initiated: boolean = false;

    protected readonly layoutDim:IDimOrientation = {
        landscape :{
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, -60),
        },
        portrait :{
            scale: new PIXI.Point(0.9, 0.9),
            position: new PIXI.Point(0, -120)
        }
    };

    private _spine:SpinePlayer;
    private resVal:number;
    protected _timeLine:gsap.core.Timeline;

    protected _gfxBg:PIXI.Graphics;

    constructor(){
        super();
    }

    setData(data:GameData){
        if(!this.initiated) this.initAnimations();
        this.resVal = MathHelper.clamp(data.Reel.amountOfScatters-2, 1, 3);
    }

    protected createGraphic(): void {
        const maxAreaSize: number = 3000;
        this._gfxBg = this.addChild(new PIXI.Graphics());
        this._gfxBg.beginFill(0x000000, 0.65);
        this._gfxBg.drawRect(-maxAreaSize * 0.5, -maxAreaSize * 0.5, maxAreaSize, maxAreaSize);
        this._gfxBg.endFill();
    }

    protected initAnimations():void{
        this.createGraphic();

        this._spine = this.addChild(new SpinePlayer("FeatureBuy"));

        this.visible = false;
        this.initiated = true;
        this.onResize();
    }


    public play():gsap.core.Timeline{
        if(!this.initiated) this.initAnimations();
        this.onResize();

        this._timeLine = Helper.setTimeline(this._timeLine,{onStart:() => {
            this.visible = true;
        }});

        this._timeLine.add(this._spine.play({animation:"JW_"+this.resVal,showOnEnd:true}),0)
        this._timeLine.fromTo(this,{alpha:0},{alpha:1,duration:0.25},0);
      
        return this._timeLine;
    }

    public stop():gsap.core.Timeline{
        this._timeLine = Helper.setTimeline(this._timeLine, {onComplete:() => {
            this.visible = false;
        }
        });
        this._timeLine.to(this,0.35,{alpha:0});
        return this._timeLine;
    }

    public onResize():void{

        this.position = ResizeHelper.calcDim(this.layoutDim).position;
        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;

        if(this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);
    }
}
